__turbopack_context__.v({
  "avatar": "StoriesRow-module-scss-module__QNHu3G__avatar",
  "bubble": "StoriesRow-module-scss-module__QNHu3G__bubble",
  "collapsed": "StoriesRow-module-scss-module__QNHu3G__collapsed",
  "item": "StoriesRow-module-scss-module__QNHu3G__item",
  "label": "StoriesRow-module-scss-module__QNHu3G__label",
  "ring": "StoriesRow-module-scss-module__QNHu3G__ring",
  "row": "StoriesRow-module-scss-module__QNHu3G__row",
  "toggle": "StoriesRow-module-scss-module__QNHu3G__toggle",
  "toggle-bubble": "StoriesRow-module-scss-module__QNHu3G__toggle-bubble",
  "toggle-count": "StoriesRow-module-scss-module__QNHu3G__toggle-count",
});
